import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["tokens", "disabled", "children", "tag", "iconStart", "iconEnd", "isLoading", "onClick", "id"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forwardRef } from 'react';
import { AnimatePresence, m } from 'framer-motion';
import Loader, { ROOT_SIZES as loaderSizes } from '@segment/matcha/components/Loader';
import { withDesignTokens } from '@segment/matcha/useDesignTokens';
import * as views from './Button.views';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
var BaseButton = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var tokens = _ref.tokens,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      children = _ref.children,
      tag = _ref.tag,
      IconStart = _ref.iconStart,
      IconEnd = _ref.iconEnd,
      _ref$isLoading = _ref.isLoading,
      isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading,
      onClick = _ref.onClick,
      id = _ref.id,
      rest = _objectWithoutProperties(_ref, _excluded);

  return _jsxs(views.Button, _objectSpread(_objectSpread(_objectSpread({
    id: id,
    as: tag !== null && tag !== void 0 ? tag : rest.href ? "a" : undefined,
    ref: ref,
    onClick: onClick,
    disabled: disabled
  }, rest), tokens), {}, {
    children: [IconStart && _jsx(IconStart, {}), _jsx(views.Content, {
      children: children
    }), isLoading && _jsx(ButtonLoader, {
      loading: true,
      delay: 0
    }), IconEnd && _jsx(IconEnd, {})]
  }));
});
var paddingBySize = {
  small: "6px 14px",
  medium: "10px 14px",
  large: "16px 22px"
};

var getPrimaryColorTokens = function getPrimaryColorTokens(theme, variant) {
  if (variant === "filled") {
    var textColor = theme.palette.neutrals.white[100];
    return {
      color: textColor,
      backgroundColor: theme.palette.brand.segmentGreen[500],
      borderColor: theme.palette.brand.segmentGreen[500],
      hoverBackgroundColor: theme.palette.brand.segmentGreen[600],
      hoverBorderColor: theme.palette.brand.segmentGreen[600],
      hoverColor: textColor,
      activeBackgroundColor: theme.palette.brand.segmentGreen[700],
      activeBorderColor: theme.palette.brand.segmentGreen[700],
      activeColor: textColor,
      focusOutlineColor: theme.palette.brand.segmentGreen[300]
    };
  }

  return {
    color: theme.palette.brand.segmentGreen[500],
    backgroundColor: "transparent",
    borderColor: theme.palette.brand.segmentGreen[500],
    hoverColor: theme.palette.neutrals.white[100],
    hoverBackgroundColor: theme.palette.brand.segmentGreen[500],
    hoverBorderColor: theme.palette.brand.segmentGreen[500],
    activeColor: theme.palette.neutrals.white[100],
    activeBackgroundColor: theme.palette.brand.segmentGreen[600],
    activeBorderColor: theme.palette.brand.segmentGreen[600],
    focusOutlineColor: theme.palette.brand.segmentGreen[500]
  };
};

var getSecondaryColorTokens = function getSecondaryColorTokens(theme, variant) {
  if (variant === "filled") {
    var textColor = theme.palette.neutrals.white[100];
    return {
      backgroundColor: theme.palette.brand.boysenberry[500],
      borderColor: theme.palette.brand.boysenberry[500],
      color: textColor,
      hoverBackgroundColor: theme.palette.brand.boysenberry[600],
      hoverBorderColor: theme.palette.brand.boysenberry[600],
      hoverColor: textColor,
      activeBackgroundColor: theme.palette.brand.boysenberry[700],
      activeBorderColor: theme.palette.brand.boysenberry[700],
      activeColor: textColor,
      focusOutlineColor: theme.palette.brand.boysenberry[300]
    };
  }

  return {
    color: theme.palette.brand.boysenberry[500],
    backgroundColor: "transparent",
    borderColor: theme.palette.brand.boysenberry[500],
    hoverColor: theme.palette.neutrals.white[100],
    hoverBackgroundColor: theme.palette.brand.boysenberry[500],
    hoverBorderColor: theme.palette.brand.boysenberry[500],
    activeColor: theme.palette.neutrals.white[100],
    activeBackgroundColor: theme.palette.brand.boysenberry[600],
    activeBorderColor: theme.palette.brand.boysenberry[600],
    focusOutlineColor: theme.palette.brand.boysenberry[500]
  };
};

export var Button = withDesignTokens(BaseButton, function (props) {
  return _objectSpread({
    padding: paddingBySize[props.size]
  }, props.expanded && {
    width: "100%",
    textAlign: "center",
    display: "flex"
  });
}, {
  light: function light(theme, props) {
    if (props.color === "primary") {
      return getPrimaryColorTokens(theme, props.variant);
    }

    return getSecondaryColorTokens(theme, props.variant);
  },
  dark: function dark(theme, props) {
    if (props.color === "primary") {
      return getPrimaryColorTokens(theme, props.variant);
    }

    return getSecondaryColorTokens(theme, props.variant);
  },
  twilioLight: function twilioLight(theme, props) {
    var textColor = theme.palette.neutrals.white[100];
    var buttonStyles = {
      hoverBackgroundColor: theme.palette.twilio.blue[70],
      hoverBorderColor: theme.palette.twilio.blue[70],
      hoverColor: textColor,
      activeBackgroundColor: theme.palette.twilio.blue[80],
      activeBorderColor: theme.palette.twilio.blue[80],
      activeColor: textColor,
      focusOutlineColor: theme.palette.twilio.blue[40]
    };

    if (props.variant === "filled") {
      return _objectSpread({
        color: textColor,
        backgroundColor: theme.palette.twilio.blue[60],
        borderColor: theme.palette.twilio.blue[60]
      }, buttonStyles);
    }

    var backgroundColor = "transparent";
    return _objectSpread({
      color: theme.palette.twilio.blue[60],
      backgroundColor: backgroundColor,
      borderColor: theme.palette.twilio.blue[60]
    }, buttonStyles);
  },
  twilioDark: function twilioDark(theme, props) {
    // eslint-disable-next-line no-warning-comments
    // TODO: Replace with twilioDark color
    var textColor = theme.palette.neutrals.white[100];
    var buttonStyles = {
      hoverBackgroundColor: theme.palette.twilio.blue[70],
      hoverBorderColor: theme.palette.twilio.blue[70],
      hoverColor: textColor,
      activeBackgroundColor: theme.palette.twilio.blue[80],
      activeBorderColor: theme.palette.twilio.blue[80],
      activeColor: textColor,
      focusOutlineColor: theme.palette.twilio.blue[40]
    };

    if (props.variant === "filled") {
      return _objectSpread({
        color: textColor,
        backgroundColor: theme.palette.twilio.blue[60],
        borderColor: theme.palette.twilio.blue[60]
      }, buttonStyles);
    }

    var backgroundColor = "transparent";
    return _objectSpread({
      color: theme.palette.twilio.blue[60],
      backgroundColor: backgroundColor,
      borderColor: theme.palette.twilio.blue[60]
    }, buttonStyles);
  },
  cdpWeek2023: function cdpWeek2023(theme, props) {
    var textColor = theme.palette.neutrals.white[100];
    var buttonStyles = {
      hoverBackgroundColor: theme.palette.cdpWeek2023.blue[80],
      hoverBorderColor: theme.palette.cdpWeek2023.blue[80],
      hoverColor: textColor,
      activeBackgroundColor: theme.palette.cdpWeek2023.blue[90],
      activeBorderColor: theme.palette.cdpWeek2023.blue[90],
      activeColor: textColor,
      focusOutlineColor: theme.palette.cdpWeek2023.blue[50]
    };

    if (props.variant === "filled") {
      return _objectSpread({
        color: textColor,
        backgroundColor: theme.palette.cdpWeek2023.blue[60],
        borderColor: theme.palette.cdpWeek2023.blue[60]
      }, buttonStyles);
    }

    var backgroundColor = "transparent";
    return _objectSpread({
      color: theme.palette.cdpWeek2023.blue[40],
      backgroundColor: backgroundColor,
      borderColor: theme.palette.cdpWeek2023.blue[40]
    }, buttonStyles);
  }
});
export var ButtonLoader = function ButtonLoader(_ref2) {
  var _ref2$loading = _ref2.loading,
      loading = _ref2$loading === void 0 ? false : _ref2$loading,
      _ref2$variant = _ref2.variant,
      variant = _ref2$variant === void 0 ? "contrast" : _ref2$variant,
      _ref2$size = _ref2.size,
      size = _ref2$size === void 0 ? "small" : _ref2$size,
      _ref2$delay = _ref2.delay,
      delay = _ref2$delay === void 0 ? 1 : _ref2$delay;
  return _jsx(AnimatePresence, {
    children: loading && _jsx(m.div, {
      initial: {
        opacity: 0,
        translateY: 2,
        width: 0
      },
      animate: {
        opacity: 1,
        translateY: 2,
        width: loaderSizes[size][0]
      },
      exit: {
        opacity: 0,
        translateY: 2,
        width: 0
      },
      transition: {
        delay: delay
      },
      children: _jsx(Loader, {
        variant: variant,
        size: size
      })
    })
  });
};